var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC98(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0000",
    fillRule: "evenodd",
    d: "M12 9.857a3.428 3.428 0 1 1-6.857 0a3.428 3.428 0 0 1 6.857 0m-1.286 0a2.143 2.143 0 1 1-4.286 0a2.143 2.143 0 0 1 4.286 0m-3.857 4.286H5.57a3 3 0 0 0 6 0h-1.286a1.714 1.714 0 0 1-3.428 0m2.571-4.286a.857.857 0 1 1-1.071-.831V8.57h.428v.455a.86.86 0 0 1 .643.831m6 .429a3.429 3.429 0 1 1 0 6.857a3.429 3.429 0 0 1 0-6.857m0 1.285a2.143 2.143 0 1 1 0 4.286a2.143 2.143 0 0 1 0-4.286m.857 2.143a.856.856 0 1 0-1.071.832V15h.429v-.454a.86.86 0 0 0 .642-.832m-.857-7.286a3 3 0 0 1 2.713 4.278a4 4 0 0 0-1.097-.708a1.714 1.714 0 1 0-3.231 0a4 4 0 0 0-1.098.708a3 3 0 0 1 2.713-4.278",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC98);
export default __webpack_public_path__ + "static/media/c98.fc7fa7d2479013eae78070dcb6b88b4a.svg";
export { ForwardRef as ReactComponent };